import { Button, Tooltip } from '$components'
import { useCreateServiceForm } from '.'
import { useTenant } from '$features/auth/hooks/use-tenant'
import { SUBSCRIPTION_EXPIRED_MESSAGE } from '$constants/subscription'

export function CreateServiceControls() {
  const { onCancel, isLoading } = useCreateServiceForm()
  const { hasSubscriptionExpired } = useTenant()

  const isButtonDisabled = hasSubscriptionExpired || isLoading

  return (
    <div className="flex gap-stack-roomy mt-auto ml-auto">
      <Button
        type="button"
        variant="ghost"
        size="lg"
        onClick={onCancel}
      >
        Cancel
      </Button>

      <Tooltip
        content={hasSubscriptionExpired ? SUBSCRIPTION_EXPIRED_MESSAGE : undefined}
        disabled={!hasSubscriptionExpired}
      >
        <Button
          isLoading={isLoading}
          type="submit"
          size="lg"
          disabled={isButtonDisabled}
        >
          Create Service
        </Button>
      </Tooltip>
    </div>
  )
}
